import axios from "axios";
//const BASE_URL = "https://kevonverify.com/api/";
const BASE_URL = "https://bveri.onrender.com/api/";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
